import { AxiosError } from "axios";

import { useMutation } from "@tanstack/react-query";

import { AmplitudeApi } from "@/api/amplitude";
import { useOpenModal } from "@/components/modal/utils/openModal";
import { useLadyIdContext } from "@/context/LadyId.context";
import {
  RedirectToRegisteredUserParams,
  redirectToRegisteredUser,
} from "@/utils/redirectToRegisteredUser";

import { SignInFormApi } from "../api";

type Params = RedirectToRegisteredUserParams & {
  isLoginFromFacebookLogin?: boolean;
  isLoginFromGoogleLogin?: boolean;
  ladyIdRedirectParam?: string;
};

export const useSendSignInForm = ({
  isLoginFromRegistration = false,
  isLoginFromFacebookLogin = false,
  isLoginFromGoogleLogin = false,
  ladyIdRedirectParam,
  // TODO: This needs refactor so bad
  // need to use useLocalLadyIdContext everywhere for redirecting,
  // and setting it in ladyprofile action buttons as well
  ladyId: ladyIdRedirectParam2,
}: Params = {}) => {
  const { openModal } = useOpenModal();
  const openInformationModal = (str: string) =>
    openModal("INFORMATION_MODAL", {
      message: str,
      statusReg: "fail",
    });

  const { ladyId } = useLadyIdContext();

  return useMutation(SignInFormApi.signIn, {
    onSuccess: async (data) => {
      // if there is data, it means there is an error
      if (data) {
        openInformationModal(data);

        if (isLoginFromFacebookLogin) {
          await AmplitudeApi.send({
            amplitude: "sign_in",
            auth_method: "facebook",
            error: true,
          });
        } else if (isLoginFromGoogleLogin) {
          await AmplitudeApi.send({
            amplitude: "sign_in",
            auth_method: "google",
            error: true,
          });
        } else {
          await AmplitudeApi.send({
            amplitude: "sign_in",
            auth_method: "sign_in",
            error: true,
          });
        }

        return;
      }

      // if not error:
      if (isLoginFromFacebookLogin) {
        await AmplitudeApi.send({
          amplitude: "sign_in",
          auth_method: "facebook",
          error: false,
        });
      } else if (isLoginFromGoogleLogin) {
        await AmplitudeApi.send({
          amplitude: "sign_in",
          auth_method: "google",
          error: false,
        });
      } else if (!isLoginFromRegistration) {
        await AmplitudeApi.send({
          amplitude: "sign_in",
          auth_method: "sign_in",
          error: false,
        });
      }

      redirectToRegisteredUser({
        isLoginFromRegistration,
        ladyId: ladyIdRedirectParam || ladyIdRedirectParam2 || ladyId,
      });
    },
    onError: async (error: AxiosError) => {
      console.log("error from login api", error);

      if (!error) return;

      const responseData = error.response?.data;
      const msg =
        typeof responseData === "string"
          ? responseData
          : "Something went wrong, please try again later";

      openInformationModal(msg);

      await AmplitudeApi.send({
        amplitude: "sign_in",
        auth_method: "sign_in",
        error: true,
      });
    },
  });
};
